import * as actionTypes from "./actionTypes";
import {
    SUBMIT_BUTTON_TEXT,
    POST_SUBMIT_BUTTON_TEXT,
    DEFAULT_QUANTITY,
} from "./constants";
import { getAmountToPurchase } from "./helpers";

export const initialState = {
    saveCardInputChecked: false,
    submitButtonText: SUBMIT_BUTTON_TEXT,
    quantityToAddInput: {
        value: DEFAULT_QUANTITY,
        error: "",
    },
    amountToPurchase: 0,
    updatingCard: false,
    processingRequest: false,
    balancePurchased: false,
    savedCreditCardInfo: null,
    stripeObjectInstance: null,
    stripeTokenData: null,
    currentPrepaidBalance: 0,
    successMessage: "",
};

export const reducer = (state, action) => {
    switch (action.type) {
        case actionTypes.TOGGLE_SAVE_CARD:
            return {
                ...state,
                saveCardInputChecked: !state.saveCardInputChecked,
            };

        case actionTypes.PURCHASE_PREPAID_BALANCE_START:
            return {
                ...state,
                processingRequest: true,
            };

        case actionTypes.PURCHASE_PREPAID_BALANCE_SUCCESS:
            const updatedPrepaidBalance =
                Number(state.amountToPurchase) +
                Number(state.currentPrepaidBalance);

            return {
                ...state,
                submitButtonText: POST_SUBMIT_BUTTON_TEXT,
                processingRequest: false,
                balancePurchased: true,
                currentPrepaidBalance: updatedPrepaidBalance,
                successMessage: `${
                    state.quantityToAddInput.value
                } icons have been added. Your updated balance is $${updatedPrepaidBalance.toFixed(
                    2
                )}.`,
            };

        case actionTypes.PURCHASE_PREPAID_BALANCE_FAILURE:
            return {
                ...state,
                processingRequest: false,
            };

        case actionTypes.RESET_FORM:
            return {
                ...state,
                submitButtonText: SUBMIT_BUTTON_TEXT,
                balancePurchased: false,
            };

        case actionTypes.HANDLE_QUANTITY_INPUT_CHANGE:
            const { quantityToAdd } = action;

            return {
                ...state,
                amountToPurchase: getAmountToPurchase({ quantityToAdd }),
                quantityToAddInput: {
                    ...state.quantityToAddInput,
                    value: quantityToAdd,
                },
            };

        case actionTypes.SET_QUANTITY_TO_ADD_INPUT_ERROR:
            return {
                ...state,
                quantityToAddInput: {
                    ...state.quantityToAddInput,
                    error: action.error,
                },
            };

        case actionTypes.CLEAR_QUANTITY_TO_ADD_INPUT_ERROR:
            return {
                ...state,
                quantityToAddInput: {
                    ...state.quantityToAddInput,
                    error: "",
                },
            };

        case actionTypes.SET_UPDATING_CARD:
            return {
                ...state,
                updatingCard: action.updatingCard,
            };

        case actionTypes.SET_SAVED_CREDIT_CARD:
            return {
                ...state,
                savedCreditCardInfo: action.savedCreditCardInfo,
            };

        case actionTypes.UPDATE_STRIPE_FORM_DATA:
            return {
                ...state,
                stripeObjectInstance: action.stripeObjectInstance,
                stripeTokenData: action.stripeTokenData,
            };

        case actionTypes.SET_CURRENT_PREPAID_BALANCE:
            return {
                ...state,
                currentPrepaidBalance: action.currentPrepaidBalance,
            };

        case actionTypes.RESET_TO_DEFAULT:
            const { savedCreditCardInfo, currentPrepaidBalance } = action;

            return {
                ...initialState,
                savedCreditCardInfo,
                currentPrepaidBalance,
            };

        default:
            return state;
    }
};
